import { PaymentTypeEnum, DisbursementTypeEnum } from '../../constants'

const objFunc = () => {
  return {
    ancillaryConfirmText: '',
    ancillaryProducts: [],
    ancillaryRequiredText: {},
    ancillaryShowApptLink: false,
    brand: '',
    disburseCardIds: undefined,
    disburseCardHolderName: '',
    disburseCardNumber: '',
    disburseCardType: '',
    disburseBankId: 0,
    disburseBankNumber: '',
    paymentCardToken: '',
    paymentCardIds: [],
    cardHolderName: '',
    cardNumber: '',
    cardType: '',
    cvv: '',
    expirationMonth: 0,
    expirationYear: 0,
    guestCard: false,

    /**
     * True if user is in guest payment flow and requests their card to be saved.
     */
    saveGuestCard: false,
    guestPayment: false,
    isRefi: false,
    loan: {},
    paymentAmount: 0.00,
    disbursementAmount: 0.00,
    disbursementType: DisbursementTypeEnum.none,
    paymentAmountType: '',
    paymentSession: false,
    pending: false,
    result: null,
    storePhoneNumber: '',
    preventRefi: false,
    isAlternatesTurn: false,
    alternateProfileId: '',
    alternateDiscAcknowledge: [],
    alternateContact: {},
    paymentType: PaymentTypeEnum.none,
    paymentKey: '',
    showAlternateSpousalConsentModal: true,
    migrateProduct: false,
    externalNavigation: false,
    principleBalance: 0,
    estimatedPayment: 0,

    autoPay: {
      enrolled: false,
      method: undefined,
      methodId: undefined,
      methodCardType: undefined,
      methodDisplayNumber: undefined,
      methodExpirationMonth: undefined,
      methodExpirationYear: undefined,
      required: false,
      scheduledAmount: undefined,
      scheduledDate: undefined
    },

    demographicsNeeded: undefined,
    demographicData: {},
    riskCheck: false,
    ofrPaymentValue: 0,
    pastDueAmount: 0,
    isAddOnLocked: false,
    isReapply: false,
    maxReapplyAmount: 0,
    settlementDiscountAmount: 0,

    origination: {
      applicationId: '',
      disclosureSubmitted: false,
      initiatorDisclosureDocuments: [],
      initiatorDisclosureData: undefined,
      productId: undefined,
      storeId: undefined
    }
  }
}

export default objFunc()

export const defaultObj = objFunc()
